"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = format;

function formatEntry(_ref, dict) {
  var type = _ref.type,
      label = _ref.label,
      properties = _ref.properties;
  var fields = Object.entries(properties).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        field = _ref3[0],
        value = _ref3[1];

    return dict.listItem.join("".concat(field, " = {").concat(value, "},"));
  });
  return dict.entry.join("@".concat(type, "{").concat(label, ",").concat(dict.list.join(fields.join('')), "}"));
}

function format(src, dict) {
  var entries = src.map(function (entry) {
    return formatEntry(entry, dict);
  }).join('');
  return dict.bibliographyContainer.join(entries);
}